const $bebe1cbb5a309c8c$export$2c4e825dc9120f87 = "https://api.dictionaryapi.dev/api/v2/entries/en";


const $624ad31b2549fc5a$export$d047a7c56db64af4 = async function(url) {
    try {
        const res = await fetch(url);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message}, 
        ${data.resolution}`);
        return data;
    } catch (err) {
        throw err;
    }
};


const $d7fcaaa29d0ffaa7$export$5ea39cf49534dea5 = {
    result: []
};
const $d7fcaaa29d0ffaa7$export$b483951181b693fd = async function(search) {
    try {
        const data = await (0, $624ad31b2549fc5a$export$d047a7c56db64af4)(`${(0, $bebe1cbb5a309c8c$export$2c4e825dc9120f87)}/${search}`);
        $d7fcaaa29d0ffaa7$export$5ea39cf49534dea5.result = data;
    } catch (err) {
        throw err;
    }
};


class $d41350ed978039fb$var$RenderView {
    _boss = document.querySelector(".rest-all");
    _parentEl = document.querySelector(".rest");
    _message = "check your internet connections";
    constructor(){
        this._parentEl.addEventListener("click", this.addParent.bind(this));
    }
    _parent(markup) {
        this._parentEl.innerHTML = "";
        this._parentEl.insertAdjacentHTML("afterbegin", markup);
    }
    render(data) {
        const markup = this._generateMarkup(data).join("");
        this._parent(markup);
    }
    renderError(message = this._message) {
        const markup = `${message}`;
        this._parent(markup);
    }
    _generateMarkup(data) {
        return data.map((x)=>{
            return `<div class="rest ">
${this._arrayPhonic(x.phonetics)}
<div class="two">
    <div class="head">${x.word}</div>
    ${this._all(x.phonetics)}
</div>
<div class="hyp"><i>${x.meanings[0].partOfSpeech} <span>${!x.phonetic ? "" : x.phonetic}</span></i></div>
${this._generateMapDefination(x.meanings[0].definitions)}
`;
        });
    }
    _arrayPhonic(x) {
        if (x.length < 1) return '<div class="wo"></div>';
        return `<audio src="${x[0].audio}" class="sound"></audio>`;
    }
    _all(x) {
        if (!x) return "";
        if (x.length < 1 || x[0].audio === "") return "";
        else return `<i class="fa fa-volume-up volume"></i>`;
    }
    _generateMapDefination(x) {
        return x.map((x)=>{
            return `<div class="meaning">${x.definition}</div>
<div class="examples"><i><b>${x.example || ""}</b></i></div>
`;
        }).join("");
    }
    loadSpinner() {
        const markup = `
    <div class="spinner">
          <i class="fa fa-spinner fas" aria-hidden="true"></i>
        </div>
    `;
        this._parent(markup);
    }
    addParent(e) {
        const click = e.target;
        if (click.classList.contains("volume")) {
            const sound = this._boss.querySelector(".sound");
            sound.play();
        }
        return click;
    }
}
var $d41350ed978039fb$export$2e2bcd8739ae039 = new $d41350ed978039fb$var$RenderView();


class $a8d410f20eeaeb6d$var$View {
    _me = document.querySelector(".together");
    _button = document.querySelector("button");
    getValue() {
        const query = document.querySelector(".input").value;
        this._clearInput();
        return query;
    }
    addListern(handler) {
        this._button.addEventListener("click", function(e) {
            e.preventDefault();
            handler();
        });
    }
    _clearInput() {
        document.querySelector(".input").value = "";
    }
}
var $a8d410f20eeaeb6d$export$2e2bcd8739ae039 = new $a8d410f20eeaeb6d$var$View();


const $b63be9b0371e788c$var$restAll = document.querySelector(".rest-all");
const $b63be9b0371e788c$var$preloader = document.querySelector(".preloader");
const $b63be9b0371e788c$var$controlSearch = async function() {
    try {
        const search = (0, $a8d410f20eeaeb6d$export$2e2bcd8739ae039).getValue();
        if (!search) return;
        $b63be9b0371e788c$var$restAll.classList.remove("hidden");
        (0, $d41350ed978039fb$export$2e2bcd8739ae039).loadSpinner();
        await $d7fcaaa29d0ffaa7$export$b483951181b693fd(search);
        (0, $d41350ed978039fb$export$2e2bcd8739ae039).render($d7fcaaa29d0ffaa7$export$5ea39cf49534dea5.result);
    } catch (err) {
        console.log(err);
        (0, $d41350ed978039fb$export$2e2bcd8739ae039).renderError(err);
    }
};
(0, $a8d410f20eeaeb6d$export$2e2bcd8739ae039).addListern($b63be9b0371e788c$var$controlSearch);
window.addEventListener("load", function() {
    $b63be9b0371e788c$var$preloader.classList.add("disappear");
});


//# sourceMappingURL=index.acf6b5a1.js.map
